export function BrandMark({ size = 34 }) {
  return <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="1" y="1" width="46" height="46" rx="12" fill="#0b110e" stroke="#4ade80" strokeOpacity=".35" />
    <path d="M11 14h23M20 14v21" stroke="#f5f7f5" strokeWidth="4" strokeLinecap="square" />
    <path d="M28 23v12h9" stroke="#4ade80" strokeWidth="4" strokeLinecap="square" />
    <path d="M35 10v9M32 13h6v4h-6z" stroke="#4ade80" strokeWidth="1.6" />
  </svg>;
}

export default function Brand({ size = 26, compact = false, mark = false }) {
  return <span className="tl-brand" style={{fontSize:size}} aria-label="TradeLog">
    {(compact || mark) && <BrandMark size={Math.round(size * 1.4)}/>}
    {!compact && <span className="tl-wordmark"><span className="tl-brand-trade">TRADE</span><span className="tl-brand-log">LOG</span></span>}
  </span>;
}
